import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useHelpModalState } from 'react-commons';
import { usePartnerParams } from '../../Shared';
import { useGlobalState } from '../../../state/persistence';
import { FlowEnum } from '../../../types';
import useStyles from '../../Shared/hooks/useStyles';

const useCheckFlow = (nextUrl?: Array<string>) => {
  usePartnerParams();
  const { t } = useTranslation('check_flow');
  const { toggleHelpModal } = useHelpModalState();
  const history = useHistory();

  const { reset, dispatchAppStore, appStore, question, dispatchQuestion } = useGlobalState();

  const transitUrlQuestionStateParams = {
    reference: question.reference,
    legalInsurance: question.legalInsurance,
  };

  const transitUrlAppStateParams = {
    email: appStore.email,
    salutation: appStore.salutation,
    firstName: appStore.firstName,
    lastName: appStore.lastName,
    ref: appStore.ref,
    referenceLabelType: appStore.referenceLabelType,
    partnerReference: appStore.partnerReference,
  };

  const transitUrlParams = {
    reference: question.reference,
    insurance: question.legalInsurance,
    email: appStore.email,
    salutation: appStore.salutation,
    firstName: appStore.firstName,
    lastName: appStore.lastName,
    ref: appStore.ref,
    referenceLabelType: appStore.referenceLabelType,
    partner: appStore.partner ? appStore.partner.slug : undefined,
  };

  const setNextUrl = (flow: FlowEnum) => {
    if (!nextUrl || !Array.isArray(nextUrl)) {
      return;
    }

    const params: { [key: string]: string } = {};
    (Object.keys(transitUrlParams) as Array<keyof typeof transitUrlParams>).forEach((key) => {
      if (transitUrlParams[key]) params[key] = transitUrlParams[key]!;
    });

    const currentNextUrl = flow === FlowEnum.CHECK_BUSINESS ? nextUrl[1] : nextUrl[0];
    const url = `${currentNextUrl}?${new URLSearchParams(params).toString()}`;
    history.push(url);
  };

  const dispatchUrlParams = () => {
    const dispatchQuestionParameters = () => {
      (Object.keys(transitUrlQuestionStateParams) as Array<keyof typeof transitUrlQuestionStateParams>).forEach(
        (key) => {
          dispatchQuestion(key, transitUrlQuestionStateParams[key]);
        },
      );
    };
    const dispatchAppParameters = () => {
      (Object.keys(transitUrlAppStateParams) as Array<keyof typeof transitUrlAppStateParams>).forEach((key) => {
        dispatchAppStore(key, transitUrlAppStateParams[key]);
      });
    };

    dispatchQuestionParameters();
    dispatchAppParameters();
  };

  const onPrivateClick = () => {
    reset();
    dispatchAppStore('flow', FlowEnum.CHECK_PRIVATE);
    dispatchUrlParams();
    setNextUrl(FlowEnum.CHECK_PRIVATE);
  };

  const onBusinessClick = () => {
    const partnerBaseUrl = 'https://www.mineko.de/gewerbe-rechtsschutz-nebenkostenpruefung';
    const defaultUrl = 'https://www.mineko.de/kontakt-gewerbe';
    let partnerSlug;
    if (appStore?.partner?.slug) {
      partnerSlug = appStore.partner.slug;
    }

    reset();
    window.location.assign(partnerSlug ? `${partnerBaseUrl}/${partnerSlug}` : defaultUrl);
  };

  const onAdministratorClick = () => {
    reset();

    window.location.assign('https://www.mineko.de/anfrage-verwalter/');
  };

  return {
    classes: useStyles(),
    t,
    onPrivateClick,
    onBusinessClick,
    onAdministratorClick,
    toggleHelpModal,
  };
};

export default useCheckFlow;
